import get from 'lodash/get';

const getIsNotificationVisible = state => get(state, 'notification.isVisible', false);
const getNotificationVariant = state => get(state, 'notification.variant', null);
const getNotificationMessage = state => get(state, 'notification.message', null);
const getNotificationStartIcon = state => get(state, 'notification.startIcon', null);
const getNotificationPersist = state => get(state, 'notification.persist', false);

export {
  getIsNotificationVisible,
  getNotificationVariant,
  getNotificationMessage,
  getNotificationStartIcon,
  getNotificationPersist,
};

export default {
  getIsNotificationVisible,
  getNotificationVariant,
  getNotificationMessage,
  getNotificationStartIcon,
  getNotificationPersist,
};
